// 10 minutes
const TOKEN_UPDATE_INTERVAL = 10 * 60 * 1000;

export { TOKEN_UPDATE_INTERVAL };
